export default __webpack_public_path__ + "static/media/gifimage03.08031b5e.gif";